import { render, staticRenderFns } from "./MdmDistributeRecord.vue?vue&type=template&id=ad81a5aa&"
import script from "./MdmDistributeRecord.vue?vue&type=script&lang=js&"
export * from "./MdmDistributeRecord.vue?vue&type=script&lang=js&"
import style0 from "./MdmDistributeRecord.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports